import { RelationshipDirection } from 'src/containers/ProjectDiagram/constants/modelConcept';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  getModelConceptClassKey,
  getModelConceptClassValue,
} from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { changeModelConceptRelationshipConnection } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/changeModelConceptRelationshipConnection';
import { getConnectedRelationshipDataForClass } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/getConnectedRelationshipDataForClass';

export const disconnectModelConceptRelationshipForClass =
  ({
    classIri,
    direction,
    iri,
  }: {
    classIri: string;
    direction: RelationshipDirection | null;
    iri: string;
  }) =>
  (model: Model) => {
    const relationships = getConnectedRelationshipDataForClass(model, classIri);
    const classKey = getModelConceptClassKey(classIri);
    relationships.forEach(({ key, from, to, value }) => {
      const isOutgoing = from === classKey;
      const isIncoming = to === classKey;

      if (iri !== value || !(isOutgoing || isIncoming)) {
        return;
      }

      let toIri = to ? getModelConceptClassValue(to) : undefined;
      let fromIri = from ? getModelConceptClassValue(from) : undefined;

      if (
        isOutgoing &&
        (!direction || direction === RelationshipDirection.OUTGOING)
      ) {
        fromIri = undefined;
      }

      if (
        isIncoming &&
        (!direction || direction === RelationshipDirection.INCOMING)
      ) {
        toIri = undefined;
      }

      changeModelConceptRelationshipConnection({
        key,
        fromIri,
        toIri,
      })(model);
    });
  };
